import React from "react";
import ReactDOM from "react-dom";

import Renderer from "./renderer";

import { setConstants } from "../Components/tasks/constantsManagement";

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const ba = require('binascii');

function validateFirebaseConfig(config) {
  const requiredKeys = [
    'apiKey',
    'authDomain',
    'projectId',
    'storageBucket',
    'messagingSenderId',
    'appId'
  ];

  const missingKeys = requiredKeys.filter(key => !config.hasOwnProperty(key));

  if (missingKeys.length > 0) {
    return {
      isValid: false,
      missingKeys,
      message: `Missing Firebase config keys: ${missingKeys.join(', ')}`
    };
  }

  return {
    isValid: true,
    missingKeys: [],
    message: 'Firebase config is valid.'
  };
}


function getTypedURLParams() {
  const params = new URLSearchParams(window.location.search);
  const paramsJSON = {};

  params.forEach((value, key) => {
      // Attempt to infer and convert data types
      if (!isNaN(value) && value.trim() !== '') {
          // Convert to number if it's a valid number
          paramsJSON[key] = Number(value);
      } else if (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') {
          // Convert to boolean if it's 'true' or 'false'
          paramsJSON[key] = value.toLowerCase() === 'true';
      } else {
          // Keep as string in all other cases
          paramsJSON[key] = value;
      }
  });

  return paramsJSON;
}

if (window.twlc) {} else {
  window.twlc = {
    renderer: {
      config: "{{component_config}}"
    }
  }
}

const render_all = () => {
  for (const [entry_id, entry_config] of Object.entries(window.twlc)) {
    // console.log(`${entry_id}:`, entry_config);
    if(entry_config["config"] === '{{component_config}}'){
      const component_config = {
        "type": "container",
        "props": {
          "style": {
            "display": "flex",
            "flexDirection": "column",
            "justifyContent": "center",
            "alignItems": "center",
            "width": "100%",
            "minHeight": "100vh",
            "backgroundColor": "white"
          }
        },
        "children": [
          {
            "name": "ik-container",
            "type": "container",
            "props": {
              "style": {
                "width": "100%"
              }
            },
            "children": [
              {
                "type": "component",
                "name": "inverkids_statistics",
                "inputs": {
                  "catalog": {
                    "1": {
                      "name": "Conociendo el Dinero",
                      "topics": {
                        "1": {
                          "name": "¿Qué es el dinero?",
                          "activities": {
                            "1": { "name": "Monedas y billetes" },
                            "2": { "name": "Identificando el dinero #1" },
                            "3": { "name": "Identificando el dinero #2" }
                          }
                        },
                        "2": {
                          "name": "Monedas",
                          "activities": {
                            "1": { "name": "Recuerda" },
                            "2": { "name": "Usando monedas" }
                          }
                        },
                        "3": {
                          "name": "Valor de las Monedas",
                          "activities": {
                            "1": { "name": "Ordenando monedas" },
                            "2": { "name": "Actividad en casa" }
                          }
                        },
                        "4": {
                          "name": "Billetes",
                          "activities": {
                            "1": { "name": "Recuerda #1" },
                            "2": { "name": "Recuerda #2" },
                            "3": { "name": "Recuerda #3" },
                            "4": { "name": "Recuerda #4" }
                          }
                        },
                        "5": {
                          "name": "Valor de los Billetes",
                          "activities": {
                            "1": { "name": "Valor de los billetes #1" },
                            "2": { "name": "Valor de los billetes #2" },
                            "3": { "name": "Valor de los billetes #3" },
                            "4": { "name": "Valor de los billetes #4" }
                          }
                        }
                      }
                    },
                    "2": {
                      "name": "Ganando y Gastando Dinero",
                      "topics": {
                        "1": {
                          "name": "Deseos y Necesidades",
                          "activities": {
                            "1": { "name": "¿Deseo o necesidad? #1" },
                            "2": { "name": "¿Deseo o necesidad? #2" },
                            "3": { "name": "Explorando mis conocimientos" }
                          }
                        },
                        "2": {
                          "name": "¿Cómo Ganamos Dinero?",
                          "activities": {
                            "1": { "name": "Recuerda #1" },
                            "2": { "name": "Recuerda #2" }
                          }
                        },
                        "3": {
                          "name": "Productos y Servicios",
                          "activities": {
                            "1": { "name": "¿Producto o servicio?" },
                            "2": { "name": "Explorando mis conocimientos" }
                          }
                        },
                        "4": {
                          "name": "¿Cómo Puedo Ganar Dinero?",
                          "activities": {
                            "1": { "name": "Recuerda" },
                            "2": { "name": "¿Ganaré dinero o no ganaré dinero?" },
                            "3": { "name": "Formas de ganar dinero #1" },
                            "4": { "name": "Formas de ganar dinero #2" },
                            "5": { "name": "Formas de ganar dinero #3" }
                          }
                        }
                      }
                    },
                    "3": {
                      "name": "Contando Monedas",
                      "topics": {
                        "2": {
                          "name": "Sumando Monedas",
                          "activities": {
                            "1": { "name": "Ayudando a Carlos" },
                            "2": { "name": "Ayudando a Carlos a sumar" }
                          }
                        }
                      }
                    },
                    "4": {
                      "name": "Ahorrando Dinero",
                      "topics": {
                        "1": {
                          "name": "¿Para Qué Sirve el Dinero?",
                          "activities": {
                            "1": { "name": "Recuerda #1" },
                            "2": { "name": "Recuerda #2" },
                            "3": { "name": "Antonio y su dinero" },
                            "4": { "name": "María y su dinero" },
                            "5": { "name": "Laura y su dinero" },
                            "6": { "name": "¿Qué hacen con su dinero? #1" },
                            "7": { "name": "¿Qué hacen con su dinero? #2" },
                            "8": { "name": "¿Qué hacen con su dinero? #3" }
                          }
                        },
                        "3": {
                          "name": "Guardar y Sacar Dinero de Mi Alcancía",
                          "activities": {
                            "1": { "name": "Recuerda" },
                            "2": { "name": "Guardando dinero en mi alcancía" },
                            "3": { "name": "Sacando dinero en mi alcancía" },
                            "4": { "name": "Guardando y sacando #1" },
                            "5": { "name": "Guardando y sacando #2" },
                            "6": { "name": "Andrea y Juan #1" },
                            "7": { "name": "Andrea y Juan #2" },
                            "8": { "name": "Andrea y Juan #3" }
                          }
                        },
                        "4": {
                          "name": "Meta de Ahorro",
                          "activities": {
                            "1": { "name": "¿Cuál es la meta de ahorro? #1" },
                            "2": { "name": "¿Cuál es la meta de ahorro? #2" },
                            "3": { "name": "¿Cuál es la meta de ahorro? #3" },
                            "4": { "name": "Precio de las metas de ahorro" }
                          }
                        }
                      }
                    },
                    "5": {
                      "name": "Gastando Dinero",
                      "topics": {
                        "1": {
                          "name": "Más Lejos o Cerca de Mi Meta",
                          "activities": {
                            "1": { "name": "Recuerda #1" },
                            "2": { "name": "Recuerda #2" },
                            "3": { "name": "La meta de ahorro de Alan" },
                            "4": { "name": "La meta de ahorro de Ana" },
                            "5": { "name": "La meta de ahorro de Juan" }
                          }
                        },
                        "2": {
                          "name": "Paciencia en el Ahorro",
                          "activities": {
                            "1": { "name": "Recuerda" },
                            "2": { "name": "Pasos para decidir" }
                          }
                        },
                        "3": {
                          "name": "Aprendiendo a Gastar",
                          "activities": {
                            "1": { "name": "Identificando el precio" }
                          }
                        },
                        "4": {
                          "name": "Comparar Precios",
                          "activities": {
                            "1": { "name": "Recuerda #1" },
                            "2": { "name": "Recuerda #2" },
                            "3": { "name": "Comparando precios #1" },
                            "4": { "name": "Comparando precios #2" },
                            "5": { "name": "Comparando precios #3" },
                            "6": { "name": "Comparando precios #4" },
                            "7": { "name": "Comparando precios #5" },
                            "8": { "name": "Comparando precios #6" },
                            "9": { "name": "Ayudando a comparar patines" },
                            "10": { "name": "Ayudando a comparar blusas" }
                          }
                        }
                      }
                    },
                    "6": {
                      "name": "Donando Dinero",
                      "topics": {
                        "1": {
                          "name": "Donación",
                          "activities": {
                            "1": { "name": "¿Qué pantalón podemos donar?" },
                            "2": { "name": "¿Qué libro podemos donar?" },
                            "3": { "name": "¿Qué guitarra podemos donar?" },
                            "4": { "name": "¿Qué patines podemos donar?" }
                          }
                        }
                      }
                    }
                  },
                  "groups": [
                    {
                      "id": "103ad9ac-5566-4643-89c0-10746919450f",
                      "school_id": "23cf51cc-3eeb-43bd-b148-410aa10cd586",
                      "name": "1",
                      "level": "1"
                    },
                    {
                      "id": "1ee9b532-67d8-4996-bb55-eeaf18709573",
                      "school_id": "23cf51cc-3eeb-43bd-b148-410aa10cd586",
                      "name": "6",
                      "level": "6"
                    },
                    {
                      "id": "296d9e59-364e-4857-b5ea-cdaf9a34cbb7",
                      "school_id": "23cf51cc-3eeb-43bd-b148-410aa10cd586",
                      "name": "2",
                      "level": "2"
                    },
                    {
                      "id": "37ac392a-402c-408f-b54f-0bc0b7d9b98a",
                      "school_id": "23cf51cc-3eeb-43bd-b148-410aa10cd586",
                      "name": "7",
                      "level": "secundaria"
                    },
                    {
                      "id": "407ec50c-ec63-44e4-af57-70b356e3ec89",
                      "school_id": "23cf51cc-3eeb-43bd-b148-410aa10cd586",
                      "name": "5",
                      "level": "5"
                    },
                    {
                      "id": "c7efb314-ec06-4879-b887-ea6f9f23789a",
                      "school_id": "23cf51cc-3eeb-43bd-b148-410aa10cd586",
                      "name": "4",
                      "level": "4"
                    },
                    {
                      "id": "fb4efdf7-959f-4cc9-939f-f699f11ed337",
                      "school_id": "23cf51cc-3eeb-43bd-b148-410aa10cd586",
                      "name": "3",
                      "level": "3"
                    }
                  ],
                  "grades": [
                    {
                      "student_name": "Estudiante 2",
                      "group_id": "296d9e59-364e-4857-b5ea-cdaf9a34cbb7",
                      "grade": "100.0",
                      "level": "2",
                      "module_number": 2,
                      "topic_number": 1,
                      "activity_number": 1,
                      "answers": { "0": { "selected": "$20", "correct": true } }
                    }
                  ]
                }
              }
            ]
          }
        ]
      };
      
      const component_state = {
        "watchList": ["grades", "groups", "catalog"],
        "grades": [],
        "groups": [],
        "catalog": {}
      };
      const component_inputs = {
        "catalog": {"1":{"name":"Conociendo el Dinero","topics":{"1":{"name":"¿Qué es el dinero?","activities":{"1":{"name":"Monedas y billetes"},"2":{"name":"Identificando el dinero #1"},"3":{"name":"Identificando el dinero #2"}}},"2":{"name":"Monedas","activities":{"1":{"name":"Recuerda"},"2":{"name":"Usando monedas"}}},"3":{"name":"Valor de las Monedas","activities":{"1":{"name":"Ordenando monedas"},"2":{"name":"Actividad en casa"}}},"4":{"name":"Billetes","activities":{"1":{"name":"Recuerda #1"},"2":{"name":"Recuerda #2"},"3":{"name":"Recuerda #3"},"4":{"name":"Recuerda #4"}}},"5":{"name":"Valor de los Billetes","activities":{"1":{"name":"Valor de los billetes #1"},"2":{"name":"Valor de los billetes #2"},"3":{"name":"Valor de los billetes #3"},"4":{"name":"Valor de los billetes #4"}}}}},"2":{"name":"Ganando y Gastando Dinero","topics":{"1":{"name":"Deseos y Necesidades","activities":{"1":{"name":"¿Deseo o necesidad? #1"},"2":{"name":"¿Deseo o necesidad? #2"},"3":{"name":"Explorando mis conocimientos"}}},"2":{"name":"¿Cómo Ganamos Dinero?","activities":{"1":{"name":"Recuerda #1"},"2":{"name":"Recuerda #2"}}},"3":{"name":"Productos y Servicios","activities":{"1":{"name":"¿Producto o servicio?"},"2":{"name":"Explorando mis conocimientos"}}},"4":{"name":"¿Cómo Puedo Ganar Dinero?","activities":{"1":{"name":"Recuerda"},"2":{"name":"¿Ganaré dinero o no ganaré dinero?"},"3":{"name":"Formas de ganar dinero #1"},"4":{"name":"Formas de ganar dinero #2"},"5":{"name":"Formas de ganar dinero #3"}}}}},"3":{"name":"Contando Monedas","topics":{"2":{"name":"Sumando Monedas","activities":{"1":{"name":"Ayudando a Carlos"},"2":{"name":"Ayudando a Carlos a sumar"}}}}},"4":{"name":"Ahorrando Dinero","topics":{"1":{"name":"¿Para Qué Sirve el Dinero?","activities":{"1":{"name":"Recuerda #1"},"2":{"name":"Recuerda #2"},"3":{"name":"Antonio y su dinero"},"4":{"name":"María y su dinero"},"5":{"name":"Laura y su dinero"},"6":{"name":"¿Qué hacen con su dinero? #1"},"7":{"name":"¿Qué hacen con su dinero? #2"},"8":{"name":"¿Qué hacen con su dinero? #3"}}},"3":{"name":"Guardar y Sacar Dinero de Mi Alcancía","activities":{"1":{"name":"Recuerda"},"2":{"name":"Guardando dinero en mi alcancía"},"3":{"name":"Sacando dinero en mi alcancía"},"4":{"name":"Guardando y sacando #1"},"5":{"name":"Guardando y sacando #2"},"6":{"name":"Andrea y Juan #1"},"7":{"name":"Andrea y Juan #2"},"8":{"name":"Andrea y Juan #3"}}},"4":{"name":"Meta de Ahorro","activities":{"1":{"name":"¿Cuál es la meta de ahorro? #1"},"2":{"name":"¿Cuál es la meta de ahorro? #2"},"3":{"name":"¿Cuál es la meta de ahorro? #3"},"4":{"name":"Precio de las metas de ahorro"}}}}},"5":{"name":"Gastando Dinero","topics":{"1":{"name":"Más Lejos o Cerca de Mi Meta","activities":{"1":{"name":"Recuerda #1"},"2":{"name":"Recuerda #2"},"3":{"name":"La meta de ahorro de Alan"},"4":{"name":"La meta de ahorro de Ana"},"5":{"name":"La meta de ahorro de Juan"}}},"2":{"name":"Paciencia en el Ahorro","activities":{"1":{"name":"Recuerda"},"2":{"name":"Pasos para decidir"}}},"3":{"name":"Aprendiendo a Gastar","activities":{"1":{"name":"Identificando el precio"}}},"4":{"name":"Comparar Precios","activities":{"1":{"name":"Recuerda #1"},"2":{"name":"Recuerda #2"},"3":{"name":"Comparando precios #1"},"4":{"name":"Comparando precios #2"},"5":{"name":"Comparando precios #3"},"6":{"name":"Comparando precios #4"},"7":{"name":"Comparando precios #5"},"8":{"name":"Comparando precios #6"},"9":{"name":"Ayudando a comparar patines"},"10":{"name":"Ayudando a comparar blusas"}}}}},"6":{"name":"Donando Dinero","topics":{"1":{"name":"Donación","activities":{"1":{"name":"¿Qué pantalón podemos donar?"},"2":{"name":"¿Qué libro podemos donar?"},"3":{"name":"¿Qué guitarra podemos donar?"},"4":{"name":"¿Qué patines podemos donar?"}}}}}},
        "groups": [{"id":"103ad9ac-5566-4643-89c0-10746919450f","school_id":"23cf51cc-3eeb-43bd-b148-410aa10cd586","name":"1","level":"1"},{"id":"1ee9b532-67d8-4996-bb55-eeaf18709573","school_id":"23cf51cc-3eeb-43bd-b148-410aa10cd586","name":"6","level":"6"},{"id":"296d9e59-364e-4857-b5ea-cdaf9a34cbb7","school_id":"23cf51cc-3eeb-43bd-b148-410aa10cd586","name":"2","level":"2"},{"id":"37ac392a-402c-408f-b54f-0bc0b7d9b98a","school_id":"23cf51cc-3eeb-43bd-b148-410aa10cd586","name":"7","level":"secundaria"},{"id":"407ec50c-ec63-44e4-af57-70b356e3ec89","school_id":"23cf51cc-3eeb-43bd-b148-410aa10cd586","name":"5","level":"5"},{"id":"c7efb314-ec06-4879-b887-ea6f9f23789a","school_id":"23cf51cc-3eeb-43bd-b148-410aa10cd586","name":"4","level":"4"},{"id":"fb4efdf7-959f-4cc9-939f-f699f11ed337","school_id":"23cf51cc-3eeb-43bd-b148-410aa10cd586","name":"3","level":"3"}],
        "grades": [{"student_name":"Estudiante 2","group_id":"296d9e59-364e-4857-b5ea-cdaf9a34cbb7","grade":"100.0","level":"2","module_number":2,"topic_number":1,"activity_number":1,"answers":{"0":{"selected":"$20","correct":true}}}]
      };
      const component_id = "no-component";
      ReactDOM.render(<Renderer component_id={component_id} component_config={component_config} component_state={component_state} component_inputs={component_inputs}/>, document.getElementById(entry_id));
    }else{
      // console.log(entry_config);
      const component_id = entry_config.component_id;
      const component_app = entry_config.app;
      const component_config = entry_config.config ? JSON.parse(ba.unhexlify(entry_config.config)) : {};
      const component_state = entry_config.state ? JSON.parse(ba.unhexlify(entry_config.state)) : {};
      let component_inputs = {}
      try{
        component_inputs = entry_config.inputs ? JSON.parse(ba.unhexlify(entry_config.inputs)) : {};
      } catch {
        component_inputs = entry_config.inputs ? entry_config.inputs : {};
      }
      const component_events = entry_config.events ? JSON.parse(ba.unhexlify(entry_config.events)) : {};
      const component_constants = entry_config.constants ? JSON.parse(ba.unhexlify(entry_config.constants)) : {};
      setConstants(component_constants)

      const firebase = entry_config.firebase_config ? JSON.parse(ba.unhexlify(entry_config.firebase_config)) : {};
      if(validateFirebaseConfig(firebase).isValid){
        window.app = initializeApp(firebase);
        window.db = getFirestore(app);
      }
      
      const params_inputs = getTypedURLParams()
      Object.entries(params_inputs).forEach(([input_name, input_value]) => {
        if(component_inputs[input_name] || !('inputs' in entry_config)){
          component_inputs[input_name] = input_value
        }
      })
      window.twlc_current_app = component_app

      console.log("should add eventlistener popstate: ", window);

      if(Object.entries(window.twlc).length==1 && entry_id=='renderer'){
        history.pushState({app: component_app, component:component_id, component_inputs:component_inputs, node:entry_id}, '', window.location.pathname+window.location.search);
        window.addEventListener('popstate', function(event) {
          console.log("State: ", event.state);
          if(event.state == null || (event.state.app == null && event.state.component == null && event.state.component_inputs == null) ){
            window.history.back()
          }
          window.twlc_current_app = event.state.app
          ReactDOM.render(<Renderer app_id={event.state.app} component_id={event.state.component} component_inputs={event.state.component_inputs}/>, document.getElementById(event.state.node));
          // Use event.state to update the application
        });
      }


      ReactDOM.render(<Renderer app_id={component_app} component_id={component_id} component_inputs={component_inputs}/>, document.getElementById(entry_id));
    }
  }
}

render_all()

if (window.twlc) {
  window.twlc_render_all = render_all
}

// hot reloading. It works by replacing a module of the application 
// during runtime with an updated one so that it’s available for instant use.
// module.hot.accept();